module.exports = __webpack_public_path__ + "static/media/39bb8fb3-84a4-4ab8-ae45-db1834f5d807.8298abb5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/39bb8fb3-84a4-4ab8-ae45-db1834f5d807.woff2
// module id = 99
// module chunks = 0